import styled, {keyframes} from "styled-components";
import {flexAdaptiveSizeItem} from "../../../../themes/architecture/css-helpers/flex";

export const amountShadowAnimation = (color: string) => keyframes`
    0% {
        text-shadow: 0px 0px 5px ${color};
    }
    100% {
        text-shadow: 0px 0px 20px ${color};
    }
`;

export const JackpotToastCurrencyDefaultBox = styled.div`
    ${flexAdaptiveSizeItem};
    padding: 0;
    @media ${props => props.theme.mediaQuery.mAndBelow} {
        padding: 0.2rem 0 0.1rem;
        font-size: 2.5rem;
    }
    color: ${props => props.theme.colors.brandSecondary};
    font-size: 2.9rem;
    font-weight: 700;
    text-align: center;
    text-shadow: 0px 0px 5px ${props => props.theme.colors.brandSecondary};
    animation: ${props => amountShadowAnimation(props.theme.colors.brandSecondary)} 0.8s ease-in-out infinite alternate forwards;
`;